import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { AdminImportStatusInfoImpl } from "../model/impl/AdminImportStatusInfoImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class AdminImportStatusInfoImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: AdminImportStatusInfoImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.rowId != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        AdminImportStatusInfoImplEncoder.fidTypeMap.get(1),
        false,
        encodable.rowId,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.payload != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        AdminImportStatusInfoImplEncoder.fidTypeMap.get(2),
        false,
        encodable.payload,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.status != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        AdminImportStatusInfoImplEncoder.fidTypeMap.get(3),
        false,
        encodable.status,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.operationType != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        AdminImportStatusInfoImplEncoder.fidTypeMap.get(4),
        false,
        encodable.operationType,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.errors != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        AdminImportStatusInfoImplEncoder.fidTypeMap.get(5),
        true,
        encodable.errors,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        AdminImportStatusInfoImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.sessionOnly != null) {
      this.baseEncoder.writeStartFid(10010, streamout);
      this.baseEncoder.writeObject(
        false,
        AdminImportStatusInfoImplEncoder.fidTypeMap.get(10010),
        false,
        encodable.sessionOnly,
        streamout,
      );
      this.baseEncoder.writeEndFid(10010, streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Integer"],
    [2, "java.lang.String"],
    [3, "com.bcdfx.model.common.api.enums.AdminImportValidation"],
    [4, "com.bcdfx.model.common.api.enums.AdminModelOperationType"],
    [5, "com.bcdfx.model.Errors"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: AdminImportStatusInfoImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            AdminImportStatusInfoImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.rowId = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AdminImportStatusInfoImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.payload = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.AdminImportValidation = this.baseEncoder.readObject(
            false,
            false,
            AdminImportStatusInfoImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.status = <CubiqTS.AdminImportValidation>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: CubiqTS.AdminModelOperationType = this.baseEncoder.readObject(
            false,
            false,
            AdminImportStatusInfoImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.operationType = <CubiqTS.AdminModelOperationType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.Errors = this.baseEncoder.readObject(
            true,
            false,
            AdminImportStatusInfoImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.errors = <CubiqTS.Errors>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AdminImportStatusInfoImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            AdminImportStatusInfoImplEncoder.fidTypeMap.get(10010),
            streamin,
          );
          encodable.sessionOnly = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return AdminImportStatusInfoImplEncoder.fidTypeMap.has(fid);
  }
}
